export const getDefaultValues = (Form) => Object.keys(Form).reduce((prev, curr) => {
    return { ...prev, [curr]: Form?.[curr]?.defaultValue, }
}, {})
